"use client";
import { faFlag } from "@fortawesome/pro-solid-svg-icons";

import { Button } from "@/components";
import ReportModal from "@/components/modal/components/report";
import { useModal } from "@/hooks/use-modal";

const ReportAnimationButton = ({ animationId }: { animationId: number }) => {
  const { openModal } = useModal();

  const onReportClicked = () =>
    openModal(() => <ReportModal id={animationId} />);

  return (
    <Button icon={faFlag} onClick={onReportClicked} type="negative">
      Report inappropriate
    </Button>
  );
};

export { ReportAnimationButton };
